const uniq = arr => [...new Set(arr)];

export default uniq;
